import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';

import{ArticleService} from '../../services/article.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-manage-template-group',
  templateUrl: './manage-template-group.component.html',
  styleUrls: ['./manage-template-group.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class ManageTemplateGroupComponent implements OnInit ,IRule {
  
  groupid:number = 0;
	userName='';
  	navigationsType=[];

  	url:any=AppSettings.API_ENDPOINT;

	type_articles:any=[];

	msg:any;

	toastr:any;

	_router:any;

	record_empty:number =0;

    record_offset:number = 0;
	

	token:any='';

  	templateGroupList = [];

  	searchTxt:string = '';

  	per_page:number=10;

  	groupId:number=0;
  	groupAddTxt:string = '';
  	groupOldTxt:string = '';
  	groupInputLabel:string = 'Add New';
  
  loader_image:boolean =true

     notification:any=[];


  @HostBinding('style.width') public width: string = '100%'; //for edge browser design issue

  constructor(msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;
  }

  ngOnInit() {

  	try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        limit:this.per_page,
        'page':'settings'
      }
      this.loader_image =true
      this.groupList(data);


    }catch(error){

      this._router.navigate(['/login']);

    }
  }

  groupLazyList(offset)
  {
    
   

    let data={
      token:this.token,
      search:this.searchTxt,
      limit:this.per_page,
      offset:offset,
      'page':'settings'
      
    }
   
  this.loader_image =true
  this.record_empty =1;
  this.groupList(data);

  }

  ngAfterViewInit(){

  	//for lazy load
  	$(window).on("scroll", function() {  


      if(this._router.url == '/settings/manage-article-group'){


        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {       


           if(this.record_empty == 0){

              this.record_offset+=this.per_page;

             

              this.groupLazyList(this.record_offset);

            }          

        }

      }


    }.bind(this));

  	$(document).ready(function(){
  		$('input').blur(function(event) {
            var inputValue = this.value;
            if (inputValue) {
                this.classList.add('value-exists');
            } else {
                this.classList.remove('value-exists');
            }
        });

        $('a.tooltip-custom').click(function(){
        		$('.approver-popup > input ').addClass('value-exists');
        });

        $('body').on('click','.tooltip-custom',function(){

         	$(this).tooltip("hide");

       	 });


	       let tl:any= $('body');
	         tl.tooltip({
	          trigger: "hover" ,
	          selector: '.tooltip-custom'
	      });

	      tl.on('show.bs.tooltip', () => {
	        //$('.tooltip-custom').not(this).remove();
	      });

	      //scrolltotop
	      $(window).scroll(function(){
				if ($(this).scrollTop() > 1) {
					$('#yt-totop').css({bottom:"25px"});
				} else {
				$('#yt-totop').css({bottom:"-50px"});
				}
			});
			
			$('#yt-totop').click(function(){
				$('html, body').animate({scrollTop: '0px'}, 800);
					return false;
			});

  	}.bind(this));
  }

  groupList(data)
  {
  	
  		this.articleService.getTemplateGroup(data).subscribe( (res)=>{

        if(res.status=='success'){
          
          this.loader_image =false

          if(res.group !=undefined ){

            this.record_empty = 0;

          } else{

           this.record_empty =1;

          }

          if(this.templateGroupList.length==0){
             
            this.templateGroupList=res.group;  
            

          } else if(res.group !=undefined ){


            res.group.forEach(element => {

              this.templateGroupList.push(element);
              
            });

          }


          this.userName=res.user.name;

          this.navigationsType=res.navigation;

          this.notification =res.notification;

            
          this.broadcast_menu();

        }else{        
          this.toastr.error(res.message, '', {timeOut: 5000});
        }
    });

  }


  searchGroupType()
  {
  	let data={
        token:this.token,
        search:this.searchTxt,
        limit:this.per_page,
        'page':'settings'
      }
     
    this.loader_image =true
    this.templateGroupList=[];
    this.record_offset=0;
    this.groupList(data);
     

  }

  deleteTemplateGroup(){

    let data={
      token:this.token,
      reqData:{
        id:this.groupid, 
        archive:true,
        'page':'settings'
      }
     
      //offset:this.record_offset
    }


    this.articleService.removeTemplateGroup(data).subscribe( (res)=>{
            

      if(res.status=='success'){

        let catI = this.templateGroupList.findIndex( (elm) => { return  elm.id ==  this.groupid});
          
        this.templateGroupList.splice(catI,1);

        this.groupid =0;


      }else{
        this.groupid =0;
      }

    });


  }

  deletetGroupList(gid){

   

    this.groupid = gid;

    
    $('#success-popup').modal('show');

  }

  addGroupType()
  {
  	let msg = "";

  	if (this.groupAddTxt.trim() != '' && (this.groupOldTxt.trim() != this.groupAddTxt.trim())) {

		let data={
			token:this.token,
			name:this.groupAddTxt,
      limit:this.per_page,
      'page':'settings'
			//offset:this.record_offset
		}
		msg =  'Group added successfully';
		if(this.groupId > 0 && this.groupInputLabel == 'Edit')
			{
				data = Object.assign(data, {'id' : this.groupId,});
        msg = 'Group updated successfully';
        
        let catI = this.templateGroupList.findIndex( (elm) => { return  elm.id == this.groupId});
          
        this.templateGroupList[catI].value= this.groupAddTxt;



      } 
      this.groupAddTxt = '';  
	    this.groupInputLabel = 'Add New ';  
	    // this.typeId = 0; 
      this.loader_image =true
      this.articleService.getTemplateGroup(data).subscribe( (res)=>{

        if(res.status=='success'){
          this.toastr.success(msg, '', {timeOut: 5000}); 

          let data={
            token:this.token,
            limit:this.per_page,
            'page':'settings'
          }
          this.templateGroupList=[];
          this.groupList(data);
        }
      })
	    // this.groupList(data);
	    
	    // this.toastr.success(msg, '', {timeOut: 5000}); 

	    //hide the popup after successfull addition
	    $('#create_template_group_popup').modal('hide');
    }else{
    	msg = 'Field can not be blank / same !';
		this.toastr.error(msg, '', {timeOut: 5000});
    }

  }

  editGroupList(id:number,val:string)
  {

  	this.groupAddTxt = val;
    this.groupOldTxt = val;
    this.groupId = id;
    this.groupInputLabel = 'Edit'; 

    //show the popup after successfull addition
	$('#create_template_group_popup').modal('show');

  }

   broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   }  


  

}
